import walidacjaWideo from '@components/form/validation/field/wideo'
import validated from '@components/form/validation/validated'

export default validated({
    t: 'Link do filmu w serwisie Youtube',
    name: 'wideo',

}, walidacjaWideo)